import { holdScrollPosition } from '~/utils';

import type { ClanType, IAccount, IAccountStatistics, IClanStatistics } from '~/Actions/ActionInvites';
import type { InferActionsType } from '~/Reducers';
import type { REQUEST_STATUSES } from '~/constants';
import type { IApiGetApplicationsResponse, IApiError } from '~/types/api';
import type { Nullable } from '~/types/generics';

export const APPLICATIONS_CHANGE_ORDER = 'APPLICATIONS_CHANGE_ORDER';
export const APPLICATIONS_CHANGE_PAGE = 'APPLICATIONS_CHANGE_PAGE';
export const APPLICATIONS_DROP_SELECTION = 'APPLICATIONS_DROP_SELECTION';
export const APPLICATIONS_JOIN_CLAN_FETCHING = 'APPLICATIONS_JOIN_CLAN_FETCHING';
export const APPLICATIONS_PROCESSING_FAILED = 'APPLICATIONS_PROCESSING_FAILED';
export const APPLICATIONS_PROCESSING_SUCCESS = 'APPLICATIONS_PROCESSING_SUCCESS';
export const APPLICATIONS_START_PROCESSING = 'APPLICATIONS_START_PROCESSING';
export const APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK = 'APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK';
export const APPLICATIONS_TOGGLE_FETCHING = 'APPLICATIONS_TOGGLE_FETCHING';
export const APPLICATIONS_TOGGLE_PLAYER_TICK = 'APPLICATIONS_TOGGLE_PLAYER_TICK';
export const APPLICATIONS_UPDATE_APPLICATIONS = 'APPLICATIONS_UPDATE_APPLICATIONS';
export const APPLICATIONS_UPDATE_ERROR = 'APPLICATIONS_UPDATE_ERROR';

export type IClanApplication = {
  account: IAccount;
  comment: Nullable<string>;
  created_at: string;
  expires_at: string;
  game: string;
  id: number;
  is_banned: boolean;
  is_hidden_statistics: boolean;
  statistics: IAccountStatistics;
  status: REQUEST_STATUSES;
  updated_at: string;
};

export type IMemberApplication = {
  clan: ClanType;
  comment: Nullable<string>;
  created_at: string;
  expires_at: string;
  game: string;
  id: number;
  is_hidden_statistics: boolean;
  statistics: IClanStatistics;
  status_changer: { id: number };
  status: REQUEST_STATUSES;
  updated_at: string;
};

export type IApplication = IClanApplication | IMemberApplication;

export type Meta = {
  collection?: string;
  offset?: number;
  total?: number;
  total_clans?: number;
};

export type ActionsType = InferActionsType<typeof actionsApplications>;

export const actionsApplications = {
  changePage: (page: number) =>
    ({
      type: APPLICATIONS_CHANGE_PAGE,
      page,
    }) as const,

  changeOrder: (order: string, isAsc: boolean) =>
    ({
      type: APPLICATIONS_CHANGE_ORDER,
      order,
      isAsc,
    }) as const,

  toggleFetching: () =>
    ({
      type: APPLICATIONS_TOGGLE_FETCHING,
    }) as const,

  updateApplications: (updateApplication: IApiGetApplicationsResponse) =>
    ({
      type: APPLICATIONS_UPDATE_APPLICATIONS,
      data: updateApplication,
    }) as const,

  updateError: (error: IApiError) =>
    ({
      type: APPLICATIONS_UPDATE_ERROR,
      error,
    }) as const,

  startProcessing: (ids: number[]) =>
    ({
      type: APPLICATIONS_START_PROCESSING,
      ids,
    }) as const,

  processingSuccess: (ids: number[]) => {
    holdScrollPosition();
    return {
      type: APPLICATIONS_PROCESSING_SUCCESS,
      ids,
    } as const;
  },

  processingFailed: (ids: number[]) => {
    holdScrollPosition();
    return {
      type: APPLICATIONS_PROCESSING_FAILED,
      ids,
    } as const;
  },

  toggleJoinClanFetching: () =>
    ({
      type: APPLICATIONS_JOIN_CLAN_FETCHING,
    }) as const,

  toggleApplicationsPlayerTick: (selectedApplicationsPlayersId: number) =>
    ({
      type: APPLICATIONS_TOGGLE_PLAYER_TICK,
      selectedApplicationsPlayersId,
    }) as const,

  toggleAllApplicationsPlayersTick: (selectedApplicationsPlayersIds: number[] = []) =>
    ({
      type: APPLICATIONS_TOGGLE_ALL_PLAYERS_TICK,
      selectedApplicationsPlayersIds,
    }) as const,

  dropSelection: () =>
    ({
      type: APPLICATIONS_DROP_SELECTION,
    }) as const,
};
